export default "<svg viewBox=\"0 0 10 8\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9.055.263v3.972h-6.77M1 4.216l2-2.038m-2 2l2 2.038\"/></svg>";


// WEBPACK FOOTER //
// webpack://ClassicEditor/ckeditor5-widget/theme/icons/return-arrow.svg